import { supabase } from './supabase';

/**
 * Unified content fetcher — reads from `publications` table (unified CMS).
 * Falls back to merging `news` + `articles` if publications is empty/missing columns.
 */

export async function fetchAllContent({ type, category, limit } = {}) {
  // Try unified publications table first
  let query = supabase
    .from('publications')
    .select('*')
    .eq('status', 'published')
    .order('created_at', { ascending: false });

  if (type) query = query.eq('content_type', type);
  if (category) query = query.eq('category', category);
  if (limit) query = query.limit(limit);

  const { data, error } = await query;

  // If publications has content, use it
  if (data?.length && data[0].title_pt) {
    return data.map(normalize);
  }

  // Fallback: merge news + articles (legacy)
  const [newsRes, articlesRes] = await Promise.all([
    supabase.from('news').select('*').eq('status', 'published').order('created_at', { ascending: false }),
    supabase.from('articles').select('*').eq('status', 'published').order('created_at', { ascending: false }),
  ]);

  const news = (newsRes.data || []).map((item) => ({ ...item, content_type: 'noticia' }));
  const articles = (articlesRes.data || []).map((item) => ({ ...item, content_type: 'artigo' }));

  let all = [...news, ...articles].sort((a, b) =>
    new Date(b.created_at) - new Date(a.created_at)
  );

  if (type) all = all.filter((i) => i.content_type === type);
  if (category) all = all.filter((i) => i.category === category);
  if (limit) all = all.slice(0, limit);

  return all.map(normalize);
}

function normalize(item) {
  return {
    ...item,
    content_type: item.content_type || 'publicacao',
    title_pt: item.title_pt || '',
    excerpt_pt: item.excerpt_pt || item.description_pt || '',
    author: item.author || 'IBRC',
    date: item.published_at || item.scheduled_at || item.created_at,
    link: item.slug
      ? (item.content_type === 'artigo' ? `/artigos/${item.slug}` : `/noticias/${item.slug}`)
      : item.pdf_url || null,
  };
}

export function getCategories(items) {
  const cats = new Map();
  items.forEach((item) => {
    const cat = item.category;
    if (cat) cats.set(cat, (cats.get(cat) || 0) + 1);
  });
  return Array.from(cats.entries()).map(([key, count]) => ({ key, count }));
}
